import React from 'react';

type TooltipProps = {
  text: string;
  open: boolean;
};

export const Tooltip: React.FC<TooltipProps> = ({
  text,
  open,
}: TooltipProps): JSX.Element => {
  return (
    <div className={`tooltip tooltip-${open ? 'open' : 'closed'}`}>{text}</div>
  );
};
